<template>
    <div>
        <!-- Status -->
        <sau-service-status :service="service"></sau-service-status>
        <!-- System Details -->
        <div class="row pt-12 pb-12" v-if="display">
            <div class="col">
                <h3>System Details</h3>
                <div class="row">
                    <div class="col">
                        <div class="sau-bx bx-pad">
                            <ul class="sau-list-display">
                                <li>
                                    <h5>Domain</h5>
                                    <p v-if="service.domain">{{ service.domain }}</p>
                                    <p v-else>Not Set</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Disk & Bandwidth -->
        <template v-if="display">
            <!-- Disk Usage -->
            <div v-if="!gotData" class="pb-12">
                <sau-loading>
                    <template slot="message">Fetching Disk Usage</template>
                </sau-loading>
            </div>
            <div v-else class="pb-12">
                <sau-bar-graph :data="diskUsage" v-if="Object.keys(diskUsage).length > 0"></sau-bar-graph>
            </div>
            <!-- Bandwidth Usage -->
            <div v-if="!gotData">
                <sau-loading>
                    <template slot="message">Fetching Bandwidth Usage</template>
                </sau-loading>
            </div>
            <div v-else>
                <sau-bar-graph :data="bandwidthUsage" v-if="Object.keys(bandwidthUsage).length > 0"></sau-bar-graph>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    props:['service'],
    data() {
        return {
            diskUsage: {},
            bandwidthUsage: {},
            domain: '',
            display: false,
        }
    },
    created() {
        // Lock down functionality if the service is suspended
        if(this.service.status.toLowerCase() != 'suspended') {
            this.display = true;
            this.startApp();
        }
    },
    methods: {
        startApp() {
            this.getAccessDetails().then(response => {
                if(response.data.status == 'success') {
                    this.domain = response.data.records.details.domain;
                    this.diskUsage = response.data.records.disk;
                    this.diskUsage['label'] = 'Disk Usage';
                    this.bandwidthUsage = response.data.records.bandwidth;
                    this.bandwidthUsage['label'] = 'Bandwidth Usage';
                }
            })
        },
    }
}
</script>

<style>
</style>
